import React from 'react';

import type { PriorityPlaylist } from '@backrs_ui/common-ui';

import { GuidePrinciplesGrid } from '@backrs_ui/grow-ui/src/components/GuidePage';
import type { ExtracurricularsGuideCorePrinciples } from '@backrs_ui/grow-ui/src/pages/ExtracurricularsGuide/content/types';
import { SuggestedPlaylistCard } from '@backrs_ui/grow-ui/src/pages/Priorities/atoms/SuggestedPlaylistCard';

import { Box, SxProps, Theme } from '@mui/material';

type CorePrinciplesSectionProps = Readonly<{
  content: ExtracurricularsGuideCorePrinciples;
  playbook?: PriorityPlaylist;
  onPlaybookClick: (playlist: PriorityPlaylist) => void;
}>;

export const CorePrinciplesSection: React.FC<CorePrinciplesSectionProps> = ({
  content,
  playbook,
  onPlaybookClick,
}) => (
  <Box sx={containerSx}>
    <Box sx={principlesColSx}>
      <GuidePrinciplesGrid principles={content.principles} columns={1} />
    </Box>
    {playbook && (
      <Box sx={playbookColSx}>
        <SuggestedPlaylistCard playlist={playbook} handlePlaylistClick={onPlaybookClick} fitWidth />
      </Box>
    )}
  </Box>
);

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  alignItems: 'start',
  gap: backrs.spacing['spacing-3xl'],
  '@container (min-width: 720px)': {
    gridTemplateColumns: 'minmax(0, 1fr) 300px',
  },
});

const principlesColSx: SxProps<Theme> = {
  maxWidth: '600px',
};

const playbookColSx: SxProps<Theme> = {
  minWidth: 0,
};
